export const injectionOrigins = [
    "https://adblockplus.org",
    "https://accounts.adblockplus.org",
    "https://new.adblockplus.org",
    "https://welcome.adblockplus.org",
    "https://getadblock.com",
    "https://vpn.getadblock.com",
];
export const getInfoCommand = "getInjectionInfo";
